import { StatePreV14, StateV14 } from './14_migrate_assekuranztarif.interface';

export const migrateAssekuranztarif = (
  previousState: StatePreV14,
  newVersion: number,
): StateV14 => {
  const newState = {
    ...previousState,
    version: newVersion,
    versicherungsnehmer: {
      ...previousState.versicherungsnehmer,
      isAssekuranztarif: previousState.versicherungsnehmer.isFinanzdienstleistertarif,
    },
  };
  delete newState.versicherungsnehmer.isFinanzdienstleistertarif;
  return newState;
};
